import { Outlet, useNavigation } from 'react-router-dom';
import { CLottie } from 'components/atoms';

export const AuthLayout = () => {
  console.log('AuthLayout');
  const { state } = useNavigation();

  if (state === 'loading') return <CLottie isFullPage containerStyle="h-screen" />;

  return (
    <main className="flex min-h-screen max-w-full flex-col overflow-x-hidden bg-primary-600 px-2 pt-4 xs:px-4 xs:pt-6 sm:px-8 lg:flex-row lg:p-0">
      <Outlet />
    </main>
  );
};

export default AuthLayout;
